import { Paper } from "@material-ui/core";
import React from "react";
import { Alert } from "../../../ui";
import CrmTrade from "../trade";
import "./phase.css.scss";

const CrmPhase = ({ done, name, showDetails, trades, newTradeId }) => (
  <div className="crm-phase-container" style={{ opacity: done ? "0.6" : "1" }}>
    <Paper
      elevation={5}
      style={{
        marginBottom: "15px",
      }}
    >
      <header className="crm-phase-header">
        <h3>{name}</h3>
      </header>
    </Paper>

    {name == "Oportunidade" && trades.length == 0 && (
      <Alert
        className="absolute"
        title="Ei, psiu!"
        message="Ainda não existem oportunidades de negócio. Busque na plataforma uma nova Oportunidade e boas vendas!"
        severity="info"
      />
    )}

    <div className="crm-phase-list-container">
      <ul className="crm-phase-list">
        {trades.map((trade, i) => (
          <CrmTrade
            {...trade}
            showDetails={showDetails}
            newTrade={newTradeId == trade.id}
            key={i}
          />
        ))}
      </ul>
    </div>
  </div>
);

export default CrmPhase;
